import { FormControlLabel, Radio, Typography } from "@mui/material";
import * as React from "react";

export default function CustomRadio({ value, title, id, className, disabled }) {
  return (
    <FormControlLabel id={id} className={className} value={value}
      label={<Typography sx={{ typography: { sm: 'h6', xs: 'body2' }, color: "black" }}>{title}</Typography>} disabled={disabled}
      control={<Radio sx={{
        "& .MuiSvgIcon-root": {
          fontSize: 20,
        },
        "&.Mui-checked": {
          color: "#c4960c",
        },
        "& .css-wg4xta-MuiGrid-root": {
          maxWidth: "100%"
        }
      }} />}
      sx={{
        "& .MuiTypography-root": {
          fontSize: "14px",
          "@media (max-width: 960px) and (min-width: 688px)": {
            fontSize: "12px",
          },
          "@media (max-width: 687px)": {
            fontSize: "10px",
          },
        }
      }}
    />
  );
}
